import AdConsole from './AdConsole';
import AddTotal from './AddTotal';
import Admin from './Admin';
import Alliance from './Alliance';
import Angle from './Angle';
import AngleThin from './AngleThin';
import Approve from './Approve';
import Archive from './Archive';
import Arrow from './Arrow';
import ArrowDnd from './ArrowDnd';
import ArticleLength from './ArticleLength';
import Bag from './Bag';
import Ban from './Ban';
import BarChart from './BarChart';
import Billing from './Billing';
import Booked from './Booked';
import BusinessClick from './BusinessClick';
import Camera from './Camera';
import Cancel from './Cancel';
import Caret from './Caret';
import Check from './Check';
import CheckCircle from './CheckCircle';
import Checkmark from './Checkmark';
import Clipboard from './Clipboard';
import Close from './Close';
import Cloud from './Cloud';
import Code from './Code';
import Cogs from './Cogs';
import Coins from './Coins';
import CoinsAlt from './CoinsAlt';
import CoinsStack from './CoinsStack';
import Collapse from './Collapse';
import Columns from './Columns';
import Compass from './Compass';
import Copy from './Copy';
import CopyAlt from './CopyAlt';
import Cross from './Cross';
import Customer from './Customer';
import Dashboard from './Dashboard';
import Database from './Database';
import Desktop from './Desktop';
import Diskette from './Diskette';
import DollarAlt from './DollarAlt';
import DollarSign from './DollarSign';
import Dot from './Dot';
import DoubleArrow from './DoubleArrow';
import Download from './Download';
import DragIndicator from './DragIndicator';
import Edit from './Edit';
import EditAlt from './EditAlt';
import Ellipsis from './Ellipsis';
import Email from './Email';
import EmailAlt from './EmailAlt';
import Envelope from './Envelope';
import Error from './Error';
import ExcludeRow from './ExcludeRow';
import Expand from './Expand';
import Export from './Export';
import Facebook from './Facebook';
import FileDownload from './FileDownload';
import Files from './Files';
import FileSearch from './FileSearch';
import FileType from './FileType';
import Filter from './Filter';
import FilterRemove from './FilterRemove';
import Format from './Format';
import GetMoney from './GetMoney';
import GroupRow from './GroupRow';
import Hide from './Hide';
import Image from './Image';
import Import from './Import';
import Incomplete from './Incomplete';
import Indicator from './Indicator';
import Info from './Info';
import Information from './Information';
import Instagram from './Instagram';
import Laptop from './Laptop';
import Like from './Like';
import List from './List';
import ListAlt from './ListAlt';
import Loading from './Loading';
import Location from './Location';
import Locked from './Locked';
import Megaphone from './Megaphone';
import Messenger from './Messenger';
import Minus from './Minus';
import MinusCircle from './MinusCircle';
import MinusSquare from './MinusSquare';
import Mobile from './Mobile';
import More from './More';
import Move from './Move';
import Notes from './Notes';
import Paperclip from './Paperclip';
import PersonAdd from './PersonAdd';
import PersonRemove from './PersonRemove';
import Phone from './Phone';
import PhoneBook from './PhoneBook';
import Placeholder from './Placeholder';
import Play from './Play';
import Plus from './Plus';
import PlusCircle from './PlusCircle';
import PlusSquare from './PlusSquare';
import Pointer from './Pointer';
import PointerAlt from './PointerAlt';
import PriceTag from './PriceTag';
import Printer from './Printer';
import Process from './Process';
import ProjectStatus from './ProjectStatus';
import QuestionCircle from './QuestionCircle';
import Reload from './Reload';
import ReportLevelFirst from './ReportLevelFirst';
import ReportLevelSecond from './ReportLevelSecond';
import ReportLevelThird from './ReportLevelThird';
import ReportLevelThirdReverse from './ReportLevelThirdReverse';
import Reset from './Reset';
import Restore from './Restore';
import RowsLimit from './RowsLimit';
import Rss from './Rss';
import Ruler from './Ruler';
import Screenshot from './Screenshot';
import Search from './Search';
import Settings from './Settings';
import Shrink from './Shrink';
import Sort from './Sort';
import SortAsc from './SortAsc';
import SortBold from './SortBold';
import SortDesc from './SortDesc';
import Speed from './Speed';
import Stop from './Stop';
import Success from './Success';
import Sync from './Sync';
import TableSort from './TableSort';
import Tablet from './Tablet';
import TargetMan from './TargetMan';
import Trash from './Trash';
import Twitter from './Twitter';
import Unlocked from './Unlocked';
import User from './User';
import Users from './Users';
import Verified from './Verified';
import Views from './Views';
import ViewsFocus from './ViewsFocus';
import Visible from './Visible';
import Warning from './Warning';
import WarningCircle from './WarningCircle';
import WarningCircleAlt from './WarningCircleAlt';
import Xandr from './Xandr';
import Xing from './Xing';
import Youtube from './Youtube';
const Icons = {
    FileType,
    Admin,
    Alliance,
    Angle,
    AngleThin,
    Archive,
    Export,
    ArticleLength,
    Approve,
    AdConsole,
    AddTotal,
    Arrow,
    ArrowDnd,
    BarChart,
    Bag,
    Billing,
    Booked,
    Check,
    CheckCircle,
    Camera,
    Cancel,
    Caret,
    Close,
    Cloud,
    Columns,
    Database,
    Desktop,
    DollarSign,
    DollarAlt,
    Dot,
    DoubleArrow,
    Download,
    Import,
    Email,
    EmailAlt,
    Edit,
    EditAlt,
    Error,
    Facebook,
    Instagram,
    Indicator,
    Twitter,
    Xing,
    Youtube,
    FileSearch,
    Files,
    FilterRemove,
    Filter,
    Image,
    Info,
    Hide,
    Like,
    List,
    ListAlt,
    Megaphone,
    Move,
    Phone,
    Plus,
    PlusCircle,
    PlusSquare,
    Printer,
    Process,
    QuestionCircle,
    Rss,
    Success,
    TargetMan,
    Trash,
    Users,
    Warning,
    WarningCircle,
    WarningCircleAlt,
    Reset,
    Restore,
    Compass,
    BusinessClick,
    Notes,
    Dashboard,
    User,
    Settings,
    Copy,
    CopyAlt,
    Views,
    ViewsFocus,
    Verified,
    Clipboard,
    Sync,
    Play,
    Ban,
    Cogs,
    Coins,
    CoinsAlt,
    CoinsStack,
    Envelope,
    Ruler,
    Reload,
    Checkmark,
    Cross,
    Locked,
    Location,
    Loading,
    Minus,
    MinusCircle,
    MinusSquare,
    Unlocked,
    Messenger,
    Mobile,
    Information,
    Tablet,
    Incomplete,
    Search,
    Diskette,
    RowsLimit,
    GroupRow,
    TableSort,
    Sort,
    SortBold,
    SortAsc,
    SortDesc,
    Ellipsis,
    DragIndicator,
    FileDownload,
    ExcludeRow,
    Paperclip,
    PersonAdd,
    PersonRemove,
    PhoneBook,
    Customer,
    GetMoney,
    Pointer,
    PointerAlt,
    PriceTag,
    Format,
    Stop,
    More,
    Speed,
    Expand,
    Shrink,
    Visible,
    Xandr,
    Placeholder,
    ProjectStatus,
    Screenshot,
    Laptop,
    Code,
    Collapse,
    ReportLevelFirst,
    ReportLevelSecond,
    ReportLevelThird,
    ReportLevelThirdReverse,
};
export default Icons;
